"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M20.747 3H3.293a.8.8 0 0 0-.793.793v12.694a.8.8 0 0 0 .793.793h9.838l2.951 5.133a.911.911 0 0 0 .952.413.8.8 0 0 0 .738-.706l.528-4.84h2.451a.8.8 0 0 0 .793-.793V3.793A.8.8 0 0 0 20.747 3Zm-2.8 12.694a1.132 1.132 0 0 0-.992.317c-.146.244-.22.525-.214.809-.024.19-.325 3.253-.325 3.253a570.607 570.607 0 0 0-1.539-2.88c-.119-.222-.23-.444-.357-.666-.071-.127-.143-.27-.23-.4a1.189 1.189 0 0 0-.182-.214 1.367 1.367 0 0 0-.952-.214H4.087V4.587h15.867v11.107h-2.007Z"
  })]
});